export const getFriendlyStatus = (shortValue) => {
    const statusMap = {
        Dft: "Draft",
        Exp: "Expired",
        Ext: "Extended",
        Lsd: "Leased",
        New: "New Listing",
        Pc: "Price Change",
        Sc: "Sold Conditional",
        Sld: "Sold",
        Sus: "Suspended",
        Ter: "Terminated"
    };

    return statusMap[shortValue] || shortValue; // Default to original value if not found
};